import { CarMileageEntry, HistoryEntry, Visit, Workshop, WorkshopImage } from '../../models';
import { GET_HISTORY_ENTRY } from '../constants/historyEntry';

/* eslint-disable camelcase */
const convertWorkshop = (workshop, image) => {
  return new Workshop(
    workshop.id,
    workshop.name,
    workshop.slug,
    workshop.country,
    workshop.city,
    workshop.street,
    workshop.street_number,
    workshop.postcode,
    workshop.latitude,
    workshop.longitude,
    workshop.website,
    workshop.description,
    workshop?.number_of_reviews,
    workshop?.average_rate,
    true,
    false,
    image,
  );
};

// eslint-disable-next-line import/prefer-default-export
export const getHistoryEntry = (data) => {
  const { id, visit, workshop } = data;

  const mileage = data?.service_report?.mileage;
  const mileageEntry = mileage
    ? new CarMileageEntry(mileage.id, mileage.mileage_in_kilometers)
    : null;

  const workshopImage =
    workshop?.workshop_images?.length > 0
      ? new WorkshopImage(workshop?.workshop_images[0].id, workshop?.workshop_images[0].image)
      : null;
  const convertedWorkshop = convertWorkshop(workshop, workshopImage);

  const visitDetail = visit
    ? new Visit(
        visit.id,
        null,
        null,
        visit?.scheduled_time,
        visit?.message_from_client,
        visit?.message_from_workshop,
        null,
        null,
        null,
        null,
        null,
        null,
        convertedWorkshop,
        null,
        null,
        visit?.service_scope_status,
        null,
        null,
      )
    : null;

  const convertedHistoryEntry = new HistoryEntry(id, visitDetail, mileageEntry);

  return (dispatch) => {
    dispatch({
      type: GET_HISTORY_ENTRY,
      ...convertedHistoryEntry,
    });
  };
};
